// OL-5 PR4 (optimisation-loop.md §"Auto-execution") — frontend mirror of the templated-transform
// KINDS (server: netlify/functions/_lib/analytics/ol5-transforms.ts REGISTRY). Kept in src/lib as a
// mirror (same pattern as deployJobs/previewUrl/golive) so the browser bundle never imports the
// server transform library (which drags @alchmystudio/config + node-only builders).
//
// transformForAction SUGGESTS which templated transform an approved action maps to, from its own
// words — a UI convenience only. The human still clicks Apply, and the backend (ol5-apply) re-
// validates the kind is a real registry key + the action is templated+approved. So a loose keyword
// match is safe: it never drives an unguarded write, only which button (if any) to offer.

export const OL5_TRANSFORM_KINDS = ['llms-txt', 'site-identity'] as const;
export type Ol5TransformKind = (typeof OL5_TRANSFORM_KINDS)[number];

/**
 * Return the transform kind an approved action clearly maps to, or null (no auto-apply → the row
 * stays hand-build / Mark-done). CONSERVATIVE — matches only on a strong signal in the title /
 * description / target. Keep the signals in sync with the server registry's transform intents.
 */
export function transformForAction(a: { title?: string | null; description?: string | null; target?: string | null }): Ol5TransformKind | null {
  const hay = [a.title, a.description, a.target].filter(Boolean).join(' ').toLowerCase();
  if (!hay) return null;
  if (hay.includes('llms.txt') || /\bllms\b/.test(hay)) return 'llms-txt';
  if (/local\s?business|json-?ld|structured\s?data|schema\.org|site identity/.test(hay)) return 'site-identity';
  return null;
}
